import * as React from "react";
import * as moment from "moment";
import MaskedInput from "react-maskedinput";
import { FormControl } from "react-bootstrap";

interface IProps {
    property: string,
    dateFormat?: string,
    currentValue: string,
    disabled?: boolean,
    includeStyle?: boolean,
    showTime?: boolean,
    borderColor?: string,
    borderWidth?: number,
    titleText?: string,
    onValueChanged: (property: string, moment: string) => void
}

interface IState {
    property: string,
    value: string,
    isValid: boolean
}

class DateTimePickerMasked extends React.Component<IProps, IState> {
    readonly state: IState = {
        property: "",
        value: "",
        isValid: true
    }

    handleFocus = () => {
        this.setState({
            property: this.props.property,
            value: this.props.currentValue,
            isValid: true
        });
    }

    handleChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let value = e.currentTarget.value;

        this.setState({
            value,
            isValid: value != '' ? moment(value).isValid() : true
        });

        this.props.onValueChanged(this.props.property, value);
    }

    handleBlur = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let value = e.currentTarget.value;

        if (this.state.isValid) {
            if (value != this.props.currentValue) {
                this.props.onValueChanged(this.props.property, value);
            }
        }

        this.setState({
            property: "",
            isValid: true
        });
    }

    render = () => {
        let dateFormat = this.props.dateFormat ?? "MM/DD/YYYY";
        const disabled = this.props.disabled != undefined ? this.props.disabled : false;
        const includeTime = this.props.showTime == undefined || this.props.showTime;
        const showTime = includeTime ? "HH:mm" : false;
        const placeholder = includeTime ? `${dateFormat.toLowerCase()} hh:mm` : dateFormat.toLowerCase();
        const title = this.props.titleText ? this.props.titleText : null;
        const dateMask = dateFormat.replace(/[M|D|Y]/g,"1");

        const style = this.props.includeStyle == false ? { borderColor: this.state.isValid ? "#ccc" : "#a94442", borderWidth: 1 } : { padding: "3px 6px", height: 26, width: 120, borderColor: this.state.isValid ? "#ccc" : "#a94442", borderWidth: 1 };

        style.borderColor = this.props.borderColor ? this.props.borderColor : style.borderColor;
        style.borderWidth = this.props.borderWidth ? this.props.borderWidth : style.borderWidth;

        return (
            <MaskedInput
                className='form-control'
                style={style}
                mask={(this.props.showTime == undefined || this.props.showTime) ? `${dateMask} 11:11` : dateMask}
                placeholder={!disabled ? placeholder : ''}
                disabled={disabled}
                value={this.state.property == this.props.property ? this.state.value : this.props.currentValue}
                onFocus={this.handleFocus}
                onChange={this.handleChange}
                onBlur={this.handleBlur}
            />
        );
    }
}

export default DateTimePickerMasked;